import { orgPackagesCount, tripOrgPackListFun } from '../../../api/orgTripAPI';
import errorHandle from '../../../utils/errorHandle';

export const FetchPackList = async (
    setTripData,
    selectedStatus,
    limit,
    offset,
    datesType,
    group,
    setLoading,
    searchRe
) => {
    setLoading(true);
    try {
        const res = await tripOrgPackListFun(selectedStatus, limit, offset, datesType, group, searchRe);
        setTripData(res.data);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const countOfPackages = async (setTotalCount, selectedStatus, datesType, group, setLoading, searchRe) => {
    setLoading(true);
    try {
        const res = await orgPackagesCount(selectedStatus, datesType, group, searchRe);
        setTotalCount(res.data.packCount);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};
